<template>
  <div class="row">
    <div class="undesirable col-12" v-if="clientTimezone">
      <div class="row mt-2 mb-3 mt-md-0">
        <div class="col-12">
          <div
              class="filter-row d-flex h-100  flex-wrap align-items-end justify-content-between justify-content-sm-start">
            <div class="datepicker">
              <span class="datepicker__label">
                   {{'behavior.date_start' | trans }}
              </span>
              <v-date-picker
                  v-model='rangeDateStart'
                  name="rangeDateStart"
                  :formats='formats'
                  title-position="left"
                  :input-props='{ readonly: true }'
                  :max-date='rangeDateFinish'
                  v-validate="'required|check-period'"
                  data-vv-validate-on="none"
                  :class="{'is-invalid': errors.has('rangeDateStart')}"
                  :min-date="minDateStart">
              </v-date-picker>

              <mdc-icon icon="date_range"></mdc-icon>
              
            </div>

            <div class="datepicker">
              <span class="datepicker__label">
                   {{'appeals.date_end' | trans }}
              </span>

              <v-date-picker
                  v-model='rangeDateEnd'
                  :formats='formats'
                  title-position="left"
                  :input-props='{ readonly: true }'
                  :max-date='rangeDateFinish'
                  :min-date="rangeDateStart">
              </v-date-picker>

              <mdc-icon icon="date_range"></mdc-icon>
            </div>
  
            <div class="item-filter mr-md-4">
              <span class="datepicker__label"> {{'behavior.within' | trans }}</span>
              <v-select v-model="protocol"
                        :options="protocolList"
                        :disabled="disabledSelect"
                        label="protocolId"
                        name="protocol"
                        :filterable="false"
                        placeholder=" "
                        :onSearch="onSearchProtocol"
                        data-vv-validate-on="none">
                <template slot="no-options">
                  <div @mousedown.stop="">
                    {{ 'report.choose_protocol' | trans }}
                  </div>
                </template>
                <template slot="option" slot-scope="option">
                  {{ option.title}}
                </template>
                <template slot="selected-option" slot-scope="option">
                  {{ option.title }}
                </template>
              </v-select>
  
            </div>
            
  
            <div class="item-filter mr-md-4">
              <span class="datepicker__label">{{'behavior.ancedent' | trans}}</span>
              <select-with-pager id="ancedentId"
                                 name="ancedent"
                                 class="load_more__select"
                                 :label="'text'"
                                 :selected=ancedentId
                                 :options="ancedents"
                                 :loading=loading
                                 :lastId=lastAncedentId
                                 :searchable="false"
                                 :isLastPage=isLastAncedentPage
                                 :optionTitle="'text'"
                                 :class="{'is-invalid': errors.has('ancedent'), 'is-clear': !ancedentId}"
                                 v-on:next-page="nextAncedentPage"
                                 v-bind:isLast="isLastAncedent"
                                 v-bind:getOptionTitle="getOptionAncedentTitle"
                                 v-on:set-selected="onSetAncedentSelected"
              >
              </select-with-pager>
  
            </div>
  
            <div class="item-filter">
              <span class="datepicker__label">{{'behavior.behavior' | trans}}</span>
              <select-with-pager id="behaviorId"
                                 name="behavior"
                                 class="load_more__select"
                                 :label="'text'"
                                 :selected=behaviorId
                                 :options="behaviorsList"
                                 :loading=loading
                                 :lastId=lastBehaviorsId
                                 :searchable="false"
                                 :isLastPage=isLastBehaviorsPage
                                 :optionTitle="'text'"
                                 :class="{'is-invalid': errors.has('behavior'), 'is-clear': !behaviorId}"
                                 v-on:next-page="nextBehaviorsPage"
                                 v-bind:isLast="isLastBehavior"
                                 v-bind:getOptionTitle="getOptionBehaviorsTitle"
                                 v-on:set-selected="onSetBehaviorsSelected"
              >
              </select-with-pager>
  
            </div>

          </div>
  
          
        </div>

        <div class="col-12">
          <span class="description-row" :class="{'invalid-feedback': errors.has('rangeDateStart')}">{{'report.description_max_period' | trans }}</span>
        </div>

        <div class="col-12 mt-0  d-lg-block">
          <div :class="{'d-flex h-100  align-items-end justify-content-end': !isMobile}">
  
  
            <button type="button"
                    class="btn btn-lightblue mt-3 mt-sm-0 mb-2 mr-2" raised
                    @click.prevent="applyFilter()">
              {{'behavior.buttons.apply' | trans }}
            </button>
            
            
            <button type="button" class="btn btn-light mb-2 mr-2" raised
                    @click.prevent="onEditBtnClick">
              {{'behavior.buttons.typical_behavior' | trans }}
            </button>

            <mdc-button class="btn button-primary mb-2 " raised
                        v-if="!isMensurationForbidden"
                        @click.prevent="onShowModalBtnClick">
              {{'behavior.buttons.create_behavior' | trans }}
            </mdc-button>
          </div>
        </div>
      </div>


      <table class="table table-sm" v-if="!isMobile && !isEmptyBehavior">
        <thead class="thead-light">
        <tr>
          <th>{{'behavior.ancedent' | trans}}</th>
          <th>{{'behavior.behavior' | trans}}</th>
          <th>{{'behavior.ub_environment' | trans}}</th>
          <th>{{'behavior.ub_behavior' | trans}}</th>
          <th class="action-cell">{{'behavior.date_time' | trans}}</th>
        </tr>
        </thead>

        <tbody>
        <tr v-if="!isLoaded">
          <td colspan="4">
            <loader class="table-loader"
                    messages="home.labels.loading_message_table"></loader>
          </td>
        </tr>
        <tr v-for="behavior in behaviors" :key="behaviors.id"
            v-if="!isEmptyBehavior && isLoaded">
          <td>
            <span v-for="(antecedent, index)  in behavior.antecedents">{{antecedent.text}}<span
                v-if="index != behavior.antecedents.length - 1">, </span> </span>
          </td>

          <td>
            <span v-for="(behaviorName, index) in behavior.behaviors">{{behaviorName.text}}<span
                v-if="index != behavior.behaviors.length - 1">, </span> </span>
          </td>

          <td>
            <span
                v-for="(effect, index) in behavior.effects">{{effect.text}}<span
                v-if="index != behavior.effects.length - 1">, </span> </span>
          </td>
  
          <td>
            <span
                v-for="(consequenceInBehavior, index) in behavior.consequenceInBehaviors">{{consequenceInBehavior.text}}<span
                v-if="index != behavior.consequenceInBehaviors.length - 1">, </span> </span>
          </td>

          <td class="action-cell">
            <span v-if="behavior.updatedAt" class="nowrap">{{behavior.updatedAt.date | toLocaleDateTime}}</span>
            <span class="nowrap" v-else>{{behavior.createdAt.date | toLocaleDateTime}}</span>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="mobile-table" v-if="isMobile">
        <div class="mobile-table__head">
          {{'behavior.ancedent' | trans}}
        </div>

        <div class="mobile-table__body">
          <div class="d-flex" v-if="!isLoaded">
            <loader class="table-loader"
                    messages="home.labels.loading_message_table"></loader>
          </div>

          <div class="mobile-table__row" v-for="behavior in behaviors"
               :key="behavior.id" v-if="isLoaded">
            <div class="title align-items-center d-flex justify-content-between"
                 :class="{hidden : activeBehaviorId != behavior.id}">
              <b>
                <span v-for="(antecedent, index)  in behavior.antecedents">{{antecedent.text}}<span
                    v-if="index != behavior.antecedents.length - 1">, </span> </span>
              </b>

              <span @click="openDescription(behavior.id)">
                          <mdc-icon icon="keyboard_arrow_right"
                                    v-if="activeBehaviorId != behavior.id"></mdc-icon>
                          <mdc-icon icon="keyboard_arrow_down"
                                    v-else></mdc-icon>
                        </span>
            </div>

            <div class="gray-dark">
              <span v-if="behavior.updatedAt">{{behavior.updatedAt.date | toLocaleDateTime}}</span>
              <span v-else>{{behavior.createdAt.date | toLocaleDateTime}}</span>
            </div>

            <div class="description pt-2"
                 :class="{hidden : activeBehaviorId != behavior.id}">
              <div>
                <p class="gray-dark">{{'behavior.behavior' | trans}}</p>
                <p><span v-for="(behaviorName, index) in behavior.behaviors">{{behaviorName.text}}<span
                    v-if="index != behavior.behaviors.length - 1">, </span> </span>
                </p>
              </div>

              <div class="pt-2">
                <p class="gray-dark">{{'behavior.ub_environment' | trans}}</p>
                <p><span v-for="(effect, index) in behavior.effects">{{effect.text}}<span
                    v-if="index != behavior.effects.length - 1">, </span> </span>
                </p>
              </div>
  
              <div class="pt-2">
                <p class="gray-dark">{{'behavior.ub_behavior' | trans}}</p>
                <p><span v-for="(consequenceInBehavior, index) in behavior.consequenceInBehaviors">{{consequenceInBehavior.text}}<span
                    v-if="index != behavior.consequenceInBehaviors.length - 1">, </span> </span>
                </p>
              </div>
            </div>
          </div>
        </div>

      </div>

      <div class="text-center" v-if="isEmptyBehavior && isLoaded">
        <h5>{{'behavior.no_data' | trans }}</h5>
      </div>

      <div class="row mt-2 mt-md-0">
        <div class="col-sm-12 col-md-5">
          <nav class="nav justify-content-center justify-content-md-start"
               v-if="!isEmptyBehavior && paginate.lastPage > 1">
            <paginate :page-count="paginate.lastPage"
                      :page-range="paginate.pageRange"
                      :margin-pages="paginate.marginPages"
                      :force-page="paginate.forcePage"
                      :click-handler="onPaginationClick"
                      :container-class="'pagination pagination-sm'"
                      :page-class="'page-item'"
                      :page-link-class="'page-link'">
              <span slot="prevContent" class="page-link">&laquo;</span>
              <span slot="nextContent" class="page-link">&raquo;</span>
            </paginate>
          </nav>
        </div>

        <div class="col-sm-12 col-md-7 text-right d-lg-none">
          <div class="row">
            <div class="col-12 col-sm-6">
              <button type="button" class="btn btn-light mb-2 mb-sm-0" raised
                      @click.prevent="onEditBtnClick">
                {{'behavior.buttons.typical_behavior' | trans }}
              </button>
            </div>

            <div class="col-12 col-sm-6" v-if="!isMensurationForbidden">
              <mdc-button class="col-12 button-primary" raised
                          @click.prevent="onShowModalBtnClick">
                {{'behavior.buttons.create_behavior' | trans }}
              </mdc-button>
            </div>
          </div>
        </div>
      </div>

      <div v-if="isModalVisible">
        <undesirable-behavior-add-modal :visible="isModalVisible"
                                        :clientId="clientId"
                                        v-on:close="onModalClose"
                                        v-on:cancel="onModalCancel">
        </undesirable-behavior-add-modal>
      </div>

      <div v-if="isEditModalVisible">
        <edit-typical-behaviors-modal :visible="isEditModalVisible"
                                      :clientId="clientId"
                                      v-on:close="onModalClose"
                                      v-on:cancel="onModalCancel">
        </edit-typical-behaviors-modal>
      </div>


    </div>

    <div class="col-12" v-else>
      <loader class="table-loader"
              messages="home.labels.loading_message_table">
      </loader>
    </div>

    <div class="col-12" v-if="clientId">
      <undesirable-behavior-chart
          v-if="clientId"
          :client-id="clientId"
          :rangeDateStart="rangeDateStart"
          :rangeDateEnd=rangeDateEnd
          :protocol-id="protocol && protocol.protocolId !== 'time' ? protocol.id : null"
          :ancedent-id="ancedentId && ancedentId.id !== 'all'  ? ancedentId.id : null"
          :behavior-id="behaviorId && behaviorId.id !== 'all' ? behaviorId.id : null"
          :is-apply-changes="changedShow"
          v-on:changedView="changedView"/>
    </div>

  </div>

</template>

<script>
  import apiUndesirableBehavior from '../api/undesirableBehavior';
  import undesirableBehaviorAddModal from './AddModal';
  import UndesirableBehaviorChart from './UndesirableBehaviorChart';
  import editTypicalBehaviorsModal from './editTypicalBehaviorsModal.vue';
  import {pagination} from '../../../common/mixins/pagination';
  import {showModal} from '../../../common/mixins/showModal';
  import {mapState, mapGetters, mapActions} from 'vuex';
  import Loader from '../../loader/components/Loader';
  import isEmpty from 'lodash/isEmpty';
  import cloneDeep from 'lodash/cloneDeep';
  import filter from 'lodash/filter';
  import Constants from '../Constants';
  import moment from 'moment';
  import timezone from 'moment-timezone';
  import lang from '../../../lang/translator';
  import forEach from 'lodash/forEach';
  import orderBy from 'lodash/orderBy';
  import {
    BarChart,
    BarChartDataset,
  } from '../../../common/chart';
  import {LineChart, LineChartDataset} from '../../../common/chart';
  import {Validator} from 'vee-validate';
  import selectWithPager from '../../../common/selectWithPager/components/SelectWithPager';
  import Manager from '../../reports/api/Manager';
  import debounce from 'lodash/debounce';
  import Auth from '../../../common/auth/Manager';

  export default {
    props: {
      'clientId': {
        type: [Number, String],
        default() {
          return Auth.getUserInfo().id || this.route.params.clientId;
        },
      },
      'clientTimezone': {
        type: [String],
        default() {
          return null;
        },
      },
    },
    data() {
      return {
        activeBehaviorId: null,
        isModalVisible: false,
        isEditModalVisible: false,
        rangeDateStart: null,
        rangeDateEnd: null,
        measurements: null,
        antecedentTypes: null,
        consequenceInBehavior: null,
        behaviorTypes: null,
        effectsTypes: null,
        antecedentLegend: null,
        behaviorLegend: null,
        effectsLegend: null,
        rangeDateFinish: this.getMaxDateFinish(new Date()),
        formats: {
          title: 'MMMM YYYY',
          weekdays: 'WW',
          navMonths: 'MMM',
          input: ['DD MMM YYYY'],
          dayPopover: 'L',
          data: ['DD MMM YYYY'],
        },
        minDateStart: this.getMinDateStart(new Date()),
        protocolList: [],
        protocol: {
          protocolId: 'time',
          title: lang.get('behavior.hours_24'),
        },
        disabledSelect: false,
        ancedentId: null,
        loading: false,
        lastAncedentId: null,
        ancedents: [{id: "all", text: lang.get('behavior.all_ancedent')}],
        isLastAncedentPage: false,
        pageBehaviors: 1,
        pageAncedents: 1,
        behaviorId: null,
        lastBehaviorsId: null,
        behaviorsList: [{id: "all", text: lang.get('report.all')}],
        isLastBehaviorsPage: false,
        changedShow: false,
        afterSetDate: false,
      };
    },

    mixins: [pagination, showModal],

    components: {
      UndesirableBehaviorChart,
      LineChart,
      Loader,
      undesirableBehaviorAddModal,
      editTypicalBehaviorsModal,
      BarChart,
      selectWithPager
    },

    computed: {
      ...mapState('behavior', [
        'behaviors',
        'isLoaded',
        'isAdded',
        'paginateData',
      ]),
      ...mapState(['route']),
      isEmptyBehavior: function() {
        return isEmpty(this.behaviors);
      },
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      ...mapGetters('auth', [
        'isMensurationForbidden',
        'isClient',
      ]),
      ...mapState('behavior', [
        'typicalBehaviors',
      ]),
      rangeDateStartTimestamp() {
        return moment(this.rangeDateStart).unix() +
            (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE);
      },
      rangeDateEndTimestamp() {
        return moment(this.rangeDateEnd).unix() +
            (Math.abs(this.rangeDateEnd.getTimezoneOffset()) *
                Constants.SECONDS_PER_MINUTE);
      },
      lineChartDataset() {
        return [this.fetchLineDatasetForChart()];
      },
      barChartAncedentDataset() {
        return this.fetchBarDatasetForChart(this.antecedentTypes,
            lang.get('behavior.ancedent'));
      },
      barChartBehaviorDataset() {
        return this.fetchBarDatasetForChart(this.behaviorTypes,
            lang.get('behavior.unwanted_behavior'));
      },
      barChartEffectsDataset() {
        return this.fetchBarDatasetForChart(this.effectsTypes,
            lang.get('behavior.aftermath'));
      },
      barChartConsequenceInBehaviorDataset() {
        return this.fetchBarDatasetForChart(this.consequenceInBehavior,
          lang.get('behavior.aftermath'));
      },
    },

    created() {

      Validator.extend('check-period', {
        getMessage: attribute => lang.get('report.description_max_period', {attribute}),
        validate: () => {
          let date = new Date(this.rangeDateStart.getFullYear(),
            (this.rangeDateStart.getMonth() + 4),
            this.rangeDateStart.getDate(),
            this.rangeDateEnd.getHours(),
            this.rangeDateEnd.getMinutes(),
            this.rangeDateEnd.getSeconds(),
            this.rangeDateEnd.getMilliseconds()
          );
          return this.rangeDateEnd.getTime() <= date.getTime();
        }
      });
      let initialPage = 1;
      if(!!localStorage.currentPage && localStorage.currentPage != 1){
        if(localStorage.getItem("currentPageHeader") === 'behaviorsList') {
          initialPage = localStorage.getItem("currentPage");
        }
        let rangeDateStart  = localStorage.getItem("rangeDateStart");
        let rangeDateEnd  = localStorage.getItem("rangeDateEnd");
        if(rangeDateStart){
          this.rangeDateStart = moment(rangeDateStart)._d;
        }
        if(rangeDateEnd){
          this.rangeDateEnd = moment(rangeDateEnd)._d;
        }
        this.ancedentId = localStorage.getItem('ancedentId');
        this.behaviorId = localStorage.getItem('behaviorId');
        this.onSearchProtocol();
        let protocolId = localStorage.getItem('protocol');
        this.protocol = filter(this.protocolList, item => item.id == protocolId )[0];
        this.clientId = localStorage.getItem('clientId') ? localStorage.getItem('clientId') : Auth.getUserInfo().id || this.route.params.clientId;
        this.applyFilter(initialPage)

      } else{
        if (this.clientTimezone) {
          this.setDate();
        }

        this.applyFilter()

      }



    },

    beforeDestroy(){
      localStorage.removeItem('currentPage');
      localStorage.removeItem('rangeDateStart');
      localStorage.removeItem('rangeDateEnd');
      localStorage.removeItem('clientId');
      localStorage.removeItem('ancedentId');
      localStorage.removeItem('behaviorId');
      localStorage.removeItem('protocolID');
    },

    methods: {
      ...mapActions('behavior', [
        'setBehaviors',
        'setGroupedBehaviors',
        'setCurrentPage',
        'setIsAdded',
        'setTypesBehaviors',
      ]),

      onSetAncedentSelected(selected){
        this.ancedentId = selected
      },

      onSetBehaviorsSelected(selected){
        this.behaviorId = selected;
      },


      isLast: function({option}) {
        return option.id == this.lastId;
      },

      isLastAncedent: function({option}) {
        return option.id == this.lastAncedentId;
      },

      isLastBehavior: function({option}) {
        return option.id == this.lastBehaviorsId;
      },

      getMaxDateFinish: function(date) {
        let clientDateEnd = moment().tz(this.clientTimezone).add(-(moment().utcOffset()), 'm');
        let minDateEnd = clientDateEnd._d;
        return minDateEnd;
      },

      getMinDateStart: function (date) {
        let minDateStart = new Date((date.getFullYear() - 1), date.getMonth(),
          date.getDate());
        return minDateStart;
      },

      toLocaleDate: function(date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM');
      },

      fetchLineDatasetForChart() {
        let data = [], i = 0;
        forEach(this.measurements, (item) => {
          data.push(
              {
                x: this.toLocaleDate(item.dateRange.end),
                y: item.perHourCount,
              },
          );
        });

        return new LineChartDataset({
          data,
        });

      },

      getRandomColor() {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
          color += letters[Math.floor(Math.random() * 16)];
        }
        if (color == '#255255') return '#333333';
        return color;
      },

      fetchBarDatasetForChart(listTypes, name) {
        let data = [], i = 0, label = name, backgroundColor, datasets = [],
            legends = [];

        let types = orderBy(listTypes, 'count', 'desc');

        forEach(types, (item) => {
          data = [
            {
              x: ++i,
              y: item.count,
            },
          ];
          label = item.title;
          backgroundColor = this.getRandomColor();
          legends.push({
            label: label,
            background: backgroundColor,
          });


          datasets.push(new BarChartDataset({
            data, label, labels: legends, backgroundColor, borderColor: backgroundColor,
          }));

        });

        return datasets;
      },

      setDate() {
        let clientDateStart = moment().
            tz(this.clientTimezone).
            subtract(Constants.COUNT_DAY, 'day').
            add(-(moment().utcOffset()), 'm');
        let clientDateEnd = moment().
            tz(this.clientTimezone).
            add(-(moment().utcOffset()), 'm');

        this.rangeDateStart = clientDateStart._d;
        this.rangeDateEnd = clientDateEnd._d;

        this.onSearchProtocol();
        this.nextAncedentPage();
        this.nextBehaviorsPage();

        this.onSendRequest();
      },

      openDescription(id) {
        if (this.activeBehaviorId !== id) {
          this.activeBehaviorId = id;
        }
        else {
          this.activeBehaviorId = null;
        }
      },

      onPaginationClick(pageNum) {
        localStorage.setItem('currentPage', pageNum);
        localStorage.setItem('currentPageHeader', 'behaviorsList');
        localStorage.setItem('rangeDateStart', this.rangeDateStart);
        localStorage.setItem('rangeDateEnd', this.rangeDateEnd);
        localStorage.setItem('clientId', this.clientId);
        localStorage.setItem('ancedentId', this.ancedentId);
        localStorage.setItem('behaviorId', this.behaviorId);
        localStorage.setItem('protocolID', this.protocol ? this.protocol.id : null);

        this.setCurrentPage(pageNum);
        this.getPageBehaviors(
            this.clientId,
            this.protocol ? this.protocol.protocolId === 'time' ? null : this.protocol.id : null,
            this.ancedentId ? this.ancedentId.id : null,
            this.behaviorId ? this.behaviorId.id : null,
            this.paginate.perPage,
            pageNum,
            this.rangeDateStartTimestamp,
            this.rangeDateEndTimestamp
        );
      },

      async onSendRequest(pageNum = 1) {

        let result = await this.$validator.validateAll();
        if (!result) {
          return;
        }

        this.paginate.page = pageNum;
        this.getPageBehaviors(
          this.clientId,
          this.protocol ? this.protocol.id === 'time' ? null : this.protocol.id : null,
          this.ancedentId ? this.ancedentId.id : null,
          this.behaviorId ? this.behaviorId.id : null,
          this.paginate.perPage,
          this.paginate.page,
          this.rangeDateStartTimestamp,
          this.rangeDateEndTimestamp
        );

        this.setIsAdded(false);
 
      },



      async applyFilter(pageNum = 1){

        let result = await this.$validator.validateAll();

        if (!result) {
          return;
        }

        this.changedShow = true;
        this.paginate.page = pageNum;

        this.getPageBehaviors(
          this.clientId,
          this.protocol ? this.protocol.protocolId === 'time' ? null : this.protocol.id : null,
          this.ancedentId && this.ancedentId.id !== 'all' ? this.ancedentId.id  : null,
          this.behaviorId && this.behaviorId.id !== 'all' ? this.behaviorId.id : null,
          this.paginate.perPage,
          this.paginate.page,
          this.rangeDateStartTimestamp,
          this.rangeDateEndTimestamp,
        ).then(()=>{
          this.afterSetDate = true;
        });
      },

      changedView(){
        this.changedShow = false;
      },

      getDateTimestamp(date) {
        return moment(date).unix() +
            (Math.abs(date.getTimezoneOffset()) * Constants.SECONDS_PER_MINUTE);
      },

      getPageBehaviors: async function(
          clientId, protocolId,antecedentId, behaviorId, perPage, page, startDate, endDate) {

          await this.setBehaviors(
              {clientId, protocolId,antecedentId, behaviorId, perPage, page, startDate, endDate});
 

          this.onPaginationBtnClick(page);
      },

      onModalCancel() {
        this.isModalVisible = false;
        this.isEditModalVisible = false;
      },

      onModalClose() {
        this.isModalVisible = false;
        this.isEditModalVisible = false;
        this.applyFilter();
      },

      onEditBtnClick() {
        this.isEditModalVisible = true;
      },
      
      

      onSearchProtocol:  debounce(
        async function (search) {
          let response = await Manager.getProtocols(
            this.clientId,
            500, 1,
            this.rangeDateStartTimestamp,
            this.rangeDateEndTimestamp,
            null,
            search,
            true);
          
          
          this.protocolList = response.data.data.items;
          
          this.protocolList.unshift({
            protocolId: 'all',
            title: lang.get('behavior.all_protocol'),
            id: 'all'
          });
          this.protocolList.unshift({
            protocolId: 'time',
            title: lang.get('behavior.hours_24'),
            id: null
          });

          
          
        }, 500
      ),


      nextAncedentPage: async function() {
        if (!this.isLastAncedentPage) {
          this.loading = true;
          let response = await apiUndesirableBehavior.getAncedents(
            this.clientId,
            this.protocol ? this.protocol.protocolId === 'time' ? null : this.protocol.id : null,
            null,
            this.perPage,
            this.pageAncedents,
            this.rangeDateStartTimestamp,
            this.rangeDateEndTimestamp);
          
          response.data.data.items.forEach((item) => {
            this.ancedents.push(item);
          });

          if (response) {
            this.loading = false;
          }
          this.lastAncedentId = this.ancedents[this.ancedents.length - 1].id;
          if (response.data.data.hasMorePages) {
            this.pageAncedents++;
          } else {
            this.isLastAncedentPage = true;
          }
        }
      },

      nextBehaviorsPage: async function() {
        if (!this.isLastBehaviorsPage) {
          this.loading = true;
          let response = await apiUndesirableBehavior.getBehaviors(
            this.clientId,
            this.protocol ? this.protocol.protocolId === 'time' ? null : this.protocol.id : null,
            null,
            this.perPage,
            this.pageBehaviors,
            this.rangeDateStartTimestamp,
            this.rangeDateEndTimestamp);

          response.data.data.items.forEach((item) => {
            this.behaviorsList.push(item);
          });

          if (response) {
            this.loading = false;
          }
          this.lastBehaviorsId = this.behaviorsList[this.behaviorsList.length - 1].id;

          if (response.data.data.hasMorePages) {
            this.pageBehaviors++;
          } else {
            this.isLastBehaviorsPage = true;
          }
        }
      },


      getOptionAncedentTitle: function({option}) {
        return option.text;
      },

      getOptionBehaviorsTitle: function({option}) {
        return option.text;
      },
    },
    watch: {
      paginateData() {
        this.setPaginate(this.paginateData);
      },
      isAdded() {
        if (this.isAdded) {
          this.onSendRequest();
        }
      },
      protocol(){
        this.ancedentId = null;
        this.behaviorId = null;
        this.isLastAncedentPage = false;
        this.isLastBehaviorsPage = false;
        this.ancedents = [{id: "all", text: lang.get('behavior.all_ancedent')}];
        this.pageBehaviors = 1;
        this.pageAncedents = 1;
        this.behaviorId = null;
        this.lastBehaviorsId = null;
        this.behaviorsList = [{id: "all", text: lang.get('report.all')}];
        this.nextAncedentPage();
        this.nextBehaviorsPage();
      },
      rangeDateStart(newValue, oldValue) {
        if (!newValue) {
          this.rangeDateStart = oldValue;
          return;
        }

        if (moment(newValue).format('DD.MM.YYYY') === moment(oldValue).format('DD.MM.YYYY') ) {
          return;
        }

        if(!!oldValue) {
          this.protocol = {
            protocolId: 'time',
            title: lang.get('behavior.hours_24')
          };
          this.onSearchProtocol();

        }

      },
      rangeDateEnd(newValue, oldValue) {
        if (!newValue) {
          this.rangeDateEnd = oldValue;
          return;
        }

        if (moment(newValue).format('DD.MM.YYYY') === moment(oldValue).format('DD.MM.YYYY') ) {
          return;
        }
        
        if(!!oldValue) {

          this.protocol = {
            protocolId: 'time',
            title: lang.get('behavior.hours_24')
          };
          this.onSearchProtocol();
        }

      },
      clientTimezone() {
        if (this.clientTimezone) {
          this.setDate();
        }
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/modules/undesirableBehavior/components/UndesirableBehaviorList.vue